// import Cookies from 'js-cookie';
// import md5 from 'js-md5'

const unfinishOrder = {
    state: {
        pageSize: 4,
        pageIndex: 1,
        total: 1,
    },

    mutations: {
        SET_UNFINISHI_PAGE_INDEX: (state, data) => {
            state.pageIndex = data;
        },
        SET_UNFINISHI_TOTAL: (state, data) => {
            state.total = data;
        },
    },
};

export default unfinishOrder;



// WEBPACK FOOTER //
// ./src/store/modules/unfinishOrder.js